import React from 'react';

import classes from './Backdrop.module.css';

const Backdrop = () => <div className={ 'Backdrop ' + classes.backdrop }></div>;

export default Backdrop;
